import { Dispatch, SetStateAction, useCallback, useState } from 'react';

import { isBrowser } from 'helpers/utils';

function useActiveStep<T>(initialValue: T): [T, Dispatch<SetStateAction<T>>] {
  const [activeStep, setActiveStepDefault] = useState(initialValue);

  const setActiveStep = useCallback<typeof setActiveStepDefault>(value => {
    setActiveStepDefault(value);

    if (isBrowser()) {
      window.scrollTo(0, 0);
    }
  }, []);

  return [activeStep, setActiveStep];
}

export default useActiveStep;
